import { render } from "./attachment-add-button.vue?vue&type=template&id=082f5f50"
import script from "./attachment-add-button.vue?vue&type=script&lang=js"
export * from "./attachment-add-button.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "@/shared/legacy/ui/button/button.module.css?vue&type=style&index=0&module=true&lang=css&external"
cssModules["$style"] = style0
/* custom blocks */
import block0 from "./attachment-add-button.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__